import React, { useEffect, useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import { capitalize } from 'lodash';

import { getPractitionerDataForSelectedPractice } from 'api/Admin/Practitioner';

import { usePractitionerImportDataContext } from 'lib/context/PractitionerImportDataContext/PractitionerImportDataContext';

import Button from 'components/shared/Buttons/Button';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import NewInfiniteScroll from 'components/shared/InfiniteScroll/NewInfiniteScroll';

const TableSelection = ({ table }) => {
  const { state, dispatch, sourcePractice } = usePractitionerImportDataContext();
  const { data = [], excludedData = [], selectAll = false } = state[table] || {};
  const topRef = useRef(null);
  const [listHeight, setListHeight] = useState(0);
  const { practitionerId } = useOutletContext();

  const params = {
    table,

    practice_id: sourcePractice.value,
    practitioner_id: practitionerId
  };

  const resData = {};

  const tableData = resData?.tableData || [];
  const handleSelectAll = () => {
    dispatch({ type: 'SELECT_ALL', payload: { table, data: tableData.map((it) => it.id) } });
  };

  const handleReset = () => {
    dispatch({ type: 'RESET_DATA', payload: { table } });
  };

  const handleSelectItem = (item) => {
    const id = item.id;
    if (selectAll) {
      const updatedData = excludedData?.includes(id)
        ? excludedData.filter((i) => i !== id)
        : [...excludedData, id];
      dispatch({ type: 'EXCLUDE_DATA', payload: { table, data: updatedData } });
    } else {
      const updatedData = data?.includes(id) ? data.filter((i) => i !== id) : [...data, id];
      dispatch({ type: 'SET_DATA', payload: { table, data: updatedData } });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const topHeight = topRef.current?.offsetHeight || 0;
      const availableHeight = window.innerHeight - topHeight - 385;
      setListHeight(availableHeight);
    };

    handleResize(); // Call on mount
    window.addEventListener('resize', handleResize); // Recalculate on resize

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const ListItem = ({ item = {} }) => {
    const isChecked = data?.includes(item.id) || (selectAll && !excludedData?.includes(item.id));
    return (
      <div
        key={item.id}
        className={`flex cursor-pointer items-center gap-3 rounded-md py-2 px-3 ${
          isChecked ? 'bg-primary-50' : ''
        }`}
        onClick={() => handleSelectItem(item)}>
        <Checkbox isChecked={isChecked} onChange={() => handleSelectItem(item)} id={item.id} />
        <h3 className="text-base font-500 text-neutral-900">{item?.name}</h3>
      </div>
    );
  };

  return (
    <div className="h-full ">
      <div className="!mt-4 flex items-center justify-between  gap-2">
        <div className=" flex items-center  gap-2">
          <Button text="Select All" onClick={handleSelectAll} outlined />
          <Button text="Reset" onClick={handleReset} outlined color="secondary" />
        </div>
      </div>
      <h4 className="!mb-2 text-lg !mt-4 font-500 text-primary-800">
        List of {capitalize(table)} items
      </h4>

      <div
        className="mt-2 left-0 flex bg-white rounded-[4px] shadow-xs z-10   w-full overflow-hidden"
        style={{ maxHeight: listHeight }}>
        <NewInfiniteScroll
          queryKey="practitionerImportData"
          queryFn={getPractitionerDataForSelectedPractice}
          queryProps={params}
          isOptions
          withSearch
          dependencies={[sourcePractice.value, practitionerId, table]}>
          {({ item }) => <ListItem item={item} />}
        </NewInfiniteScroll>
      </div>
    </div>
  );
};

export default withErrorBoundary(TableSelection);
